import { useRouterQueryParams } from "@circle-react/hooks/useRouterQueryParams";

export const useOnboardingWhiteLabel = currentCommunity => {
  const { request_host } = useRouterQueryParams();

  const rootUrl = currentCommunity?.root_url;
  const isWhiteLabelEnabled = currentCommunity?.white_label;

  const isAdminLogin = request_host === rootUrl;

  return {
    shouldShowPoweredByCircle: !isWhiteLabelEnabled && !isAdminLogin,
  };
};
